/**
 * Configure your Gatsby site with this file.
 *
 * See: https://www.gatsbyjs.com/docs/gatsby-config/
 */
module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: `LSU DMAE`,
    fullTitle: `LSU Digital Media Arts & Engineering`,
    department: `Digital Media Arts & Engineering`,
    description: `LSU's Digital Media Arts & Engineering is an undergraduate minor and initial master's degree including VFX, animation, UX, web development and game development`,
    author: `marc aubanel`,
    telephone: `+1 (225) 578-8907`,
    siteUrl: `https://dmae.cct.lsu.edu`,
    twitter: `DMAELSU`,
    facebook: `@dmaelsu`,
    facebookAppId: `879595098735829`,
    googeAPIKey: `AIzaSyDghgDgcNHowDqNqiNN1wy0xQU3TM4VSrs`,
    instagram: `dmaelsu`,
    defaultOGType: `university website`,
    mainEmail: "maubanel@cct.lsu.edu",
    latitude: "30.407483",
    longitude: "-91.1726511",
    googleMapLink:
      "https://www.google.com/maps/place/Digital+Media+Center/@30.407483,-91.1726511/data=!3m1!4b1!4m2!3m1!1s0x8626a6e00af1a36b:0xc0e913a5a5b2ff7a",
    administrator: "Marc Aubanel",
    facebookUrl: "https://facebook.com/dmaelsu",
    twitterUrl: "https://twitter.com/dmaelsu",
    instagramUrl: "https://instagram.com/dmaelsu",
    streetAddress: "Digital Media Center, 340 E Parker Blvd",
    city: "Baton Rouge",
    state: "Louisiana",
    publisher: "DMAE LSU",
    zip: "70803",
    keywords: [
      "home page",
      "index",
      "louisiana state university",
      "lsu",
      "video game design courses",
      "lsu digital media center",
      "video game programmer",
      "gaming schools",
      "gaming university",
      "louisiana state university",
      "digital arts programs",
      "video game university",
      "faculty",
      "newsletter",
      "dmae minor",
      "dmae master",
      "animation degree",
      "master degree",
      "digital media",
      "visual effects courses",
      "vfx courses",
      "video game colleges",
      "video game schools",
      "masters in digital media",
      "digital media certification",
      "video game courses",
      "video games lsu",
      "animation lsu",
      "vfx lsu",
      "digital media lsu",
      "ux",
      "ui",
    ],
  },
  plugins: [
    `gatsby-transformer-remark-vimeo-basic`,
    `gatsby-plugin-svgr-svgo`,
    `gatsby-transformer-remark-youtube`,
    {
      resolve: `gatsby-transformer-remark`,
      options: {
         plugins: [`gatsby-remark-responsive-iframe`],
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/assets/img`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `posts`,
        path: `${__dirname}/src/assets/posts/`,
      },
    },
    // {
    //   resolve: `gatsby-plugin-page-creator`,
    //   options: {
    //     path: `${__dirname}/src/assets/posts`,
    //   },
    // },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `pages`,
        path: `${__dirname}/src/pages`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `content`,
        path: `${__dirname}/src/components/faq`,
      },
    },
    {
      resolve: `gatsby-plugin-mailchimp`,
      options: {
        endpoint: `https://lsu.us2.list-manage.com/subscribe/post?u=00524faa0db99e31461771b0f&amp;id=2431b053ee`, // string; add your MC list endpoint here; see instructions below
        timeout: 3500, // number; the amount of time, in milliseconds, that you want to allow mailchimp to respond to your request before timing out. defaults to 3500
      },
    },
    `gatsby-remark-images`,
    {
      resolve: `gatsby-plugin-mdx`,
      options: {
        extensions: [`.mdx`, `.md`, `.markdown`],
        gatsbyRemarkPlugins: [
          {
            resolve: `gatsby-remark-images`,
            options: {
              maxWidth: 1200,
            },
          },
        ],
      },
    },
    {
      resolve: "gatsby-plugin-robots-txt",
      options: {
        host: "https://dmae.cct.lsu.edu",
        sitemap: "https://dmae.cct.lsu.edu/sitemap-index.xml",
        policy: [{ userAgent: "*", allow: "/" }],
      },
    },
    {
      resolve: "gatsby-plugin-sitemap",
      options: {
        output: "/",
        query: `{
  siteBuildMetadata {
    buildTime
  }
  site {
    siteMetadata {
      siteUrl
    }
  }
  allMdx(
    sort: {frontmatter: {date: DESC}}
    filter: {frontmatter: {published: {ne: "draft"}}}
  ) {
    nodes {
      frontmatter {
        dateModified
      }
      fields{
        slug
      }
    }
  }
  allSitePage(
    filter: {path: {regex: "//news(?![/,-])|/events(?!/)|projects(?!/)|^/[^/,^404]+/$/"}}
  ) {
    edges {
      node {
        path
      }
    }
  }
}`,
        resolveSiteUrl: ({
          site: {
            siteMetadata: { siteUrl },
          },
        }) => siteUrl,
        resolvePages: ({
          allMdx: { nodes: mdxs },
          siteBuildMetadata,
          allSitePage: { edges: asp },
        }) => {
          const posts = mdxs.map(mdx => {
            return {
              path: `${mdx.fields.slug}`,
              lastmod: mdx.frontmatter.dateModified,
              changefreq: `weekly`,
              priority: 0.7,
            }
          })

          const staticPages = asp.map(data => {
            return {
              path: data.node.path,
              lastmod: siteBuildMetadata.buildTime,
              changefreq: "weekly",
              priority: 0.9,
            }
          })

          const home = {
            path: "/",
            lastmod: siteBuildMetadata.buildTime,
            changefreq: "weekly",
            priority: 1.0,
          }

          return [...posts, home, ...staticPages]
        },
        serialize: ({ path, lastmod, changefreq, priority }) => {
          return {
            url: path,
            lastmod,
            changefreq,
            priority,
          }
        },
      },
    },
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        // You can add multiple tracking ids and a pageview event will be fired for all of them.
        trackingIds: [
          "AW-952596235",
          "G-FRDKMBGWS3",
            

          // Marketing Platform advertising products (Display & Video 360, Search Ads 360, and Campaign Manager)
        ],
        // This object gets passed directly to the gtag config command
        // This config will be shared across all trackingIds
        gtagConfig: {
          optimize_id: "OPT_CONTAINER_ID",
          anonymize_ip: true,
          cookie_expires: 0,
        },
        // This object is used for configuration specific to this plugin
        pluginConfig: {
          // Puts tracking script in the head instead of the body
          head: true,
          // Setting this parameter is also optional
          respectDNT: true,
          // Defaults to https://www.googletagmanager.com
          origin: "https://www.googletagmanager.com",
          // Delays processing pageview events on route update (in milliseconds)
          delayOnRouteUpdate: 0,
        },
      },
    },

    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: `Louisiana State University Digital Media Arts & Engineering Website`,
        short_name: `LSU DMAE Website`,
        start_url: `/`,
        background_color: `#212120`,
        theme_color: `#e0e0dc`,
        // Enables "Add to Homescreen" prompt and disables browser UI (including back button)
        // see https://developers.google.com/web/fundamentals/web-app-manifest/#display
        display: `standalone`,
        icon: `src/assets/img/faq/icon/icons-512.png`, // This path is relative to the root of the site.
        icon_options: {
          // For all the options available,
          // please see the section "Additional Resources" below.
          purpose: `any maskable`,
        },
        cache_busting_mode: `none`,
        include_favicon: false,
        legacy: false,
      },
    },
    {
      resolve: "gatsby-plugin-offline",
      options: {
        precachePages: [`/about/`, `/contact/`],
        workboxConfig: {
          globPatterns: ["**/icons-*"],
        },
      },
    },
    {
      resolve: `gatsby-plugin-sharp`,
      options: {
        defaults: {
          formats: [`auto`, `webp`, `avif`],
          placeholder: `blurred`,
          quality: 50,
          breakpoints: [300, 576, 768, 992, 1200, 1400, 1920],
          backgroundColor: `transparent`,
          tracedSVGOptions: {},
          blurredOptions: {},
          jpgOptions: {},
          pngOptions: {},
          webpOptions: {},
          avifOptions: {},
        },
      },
    },
    "gatsby-plugin-image",
    `gatsby-transformer-sharp`,
    "gatsby-plugin-sass",
  ],
}
